import { doc, getDoc } from "firebase/firestore";
import { dbAccounts } from "../../../backend/firebaseConfig";

const PARAPLANNING_ROOT_PATH = "Changes/Paraplanning";

const sortCategories = (categories = []) => {
  return [...categories].sort(
    (a, b) => (a.displayOrder || 999) - (b.displayOrder || 999),
  );
};

const sortItems = (items = []) => {
  return [...items].sort(
    (a, b) =>
      (a.displayOrder || 999) - (b.displayOrder || 999) ||
      (a.name || "").localeCompare(b.name || ""),
  );
};

const normaliseSnapshotCatalog = (catalogId, catalogVersionData = {}) => {
  const snapshot = catalogVersionData.snapshot || catalogVersionData;

  const categories = (snapshot.categories || []).map((category) => ({
    id: category.id,
    name: category.name || category.categoryName || category.id,
    displayOrder: category.displayOrder || 999,
    isActive: category.isActive !== false,
    items: sortItems(
      (category.items || []).map((item) => ({
        id: item.id,
        name: item.name || item.itemName || item.id,
        description: item.description || "",
        amount: item.amount || 0,
        amountPrefix: item.amountPrefix || "",
        amountType: item.amountType || "fixed",
        currency: item.currency || "GBP",
        displayOrder: item.displayOrder || 999,
        isActive: item.isActive !== false,
        visibleOnFrontend: item.visibleOnFrontend !== false,
        modifiers: item.modifiers || [],
        ...item,
      })),
    ),
  }));

  return {
    id: catalogId,
    name:
      snapshot.name ||
      snapshot.catalogName ||
      catalogVersionData.catalogName ||
      catalogId,
    catalogName:
      snapshot.catalogName ||
      snapshot.name ||
      catalogVersionData.catalogName ||
      catalogId,
    catalogId,
    notes: snapshot.notes || catalogVersionData.notes || "",
    currentVersionId: catalogVersionData.versionId || "",
    categories: sortCategories(categories),
  };
};

export const getCurrentParaplanningVersion = async () => {
  const rootRef = doc(dbAccounts, PARAPLANNING_ROOT_PATH);
  const rootSnap = await getDoc(rootRef);

  // console.log("[ChargesService] Root path:", rootRef.path);
  // console.log("[ChargesService] Root exists:", rootSnap.exists());

  // if (!rootSnap.exists()) {
  //   throw new Error("Paraplanning charges root document not found.");
  // }

  const rootData = rootSnap.data();
  const currentVersionId = rootData.currentVersionId;

  // console.log("[ChargesService] Root data:", rootData);
  // console.log("[ChargesService] Current version ID:", currentVersionId);

  if (!currentVersionId) {
    // throw new Error(
    //   "No current paraplanning charges version has been published.",
    // );
  }

  const versionRef = doc(
    dbAccounts,
    PARAPLANNING_ROOT_PATH,
    "VersionBatches",
    currentVersionId,
  );

  const versionSnap = await getDoc(versionRef);

  // console.log("[ChargesService] Current version path:", versionRef.path);
  // console.log("[ChargesService] Current version exists:", versionSnap.exists());

  // if (!versionSnap.exists()) {
  //   throw new Error(`Current charges version not found: ${currentVersionId}`);
  // }

  const versionData = {
    id: versionSnap.id,
    versionId: versionSnap.id,
    ...versionSnap.data(),
  };

  // console.log("[ChargesService] Current version data:", versionData);

  return versionData;
};

export const getParaplanningCatalogById = async (catalogId) => {
  // console.log("[ChargesService] getParaplanningCatalogById:", catalogId);

  if (!catalogId) return null;

  const versionData = await getCurrentParaplanningVersion();

  const catalogVersionData = versionData.catalogs?.[catalogId];

  // console.log("[ChargesService] Catalog version data:", {
  //   catalogId,
  //   catalogVersionData,
  // });

  if (!catalogVersionData) {
    // console.warn("[ChargesService] Catalog not found in current version:", {
    //   catalogId,
    //   availableCatalogs: Object.keys(versionData.catalogs || {}),
    // });

    return null;
  }

  const catalog = normaliseSnapshotCatalog(catalogId, {
    ...catalogVersionData,
    versionId: versionData.versionId,
  });

  // console.log("[ChargesService] Normalised catalog:", catalog);

  return catalog;
};

export const getParaplanningCatalogs = async () => {
  // console.log("[ChargesService] getParaplanningCatalogs");

  const versionData = await getCurrentParaplanningVersion();

  const catalogsObject = versionData.catalogs || {};

  const catalogs = Object.entries(catalogsObject).map(
    ([catalogId, catalogVersionData]) =>
      normaliseSnapshotCatalog(catalogId, {
        ...catalogVersionData,
        versionId: versionData.versionId,
      }),
  );

  // console.log("[ChargesService] Normalised all catalogs:", catalogs);

  return catalogs;
};

export const getParaplanningChargeItemByIds = async ({
  catalogId,
  categoryId,
  itemId,
}) => {
  // console.log("[ChargesService] getParaplanningChargeItemByIds:", {
  //   catalogId,
  //   categoryId,
  //   itemId,
  // });

  // if (!catalogId || !categoryId || !itemId) {
  //   throw new Error("Missing charge catalogue, category or item id.");
  // }

  const catalog = await getParaplanningCatalogById(catalogId);

  if (!catalog) {
    // throw new Error(
    //   `Charge catalogue not found in current version: ${catalogId}`,
    // );
  }

  const category = (catalog.categories || []).find(
    (category) => category.id === categoryId,
  );

  // console.log("[ChargesService] Matched category:", category);

  if (!category) {
    // throw new Error(
    //   `Charge category not found in current version: ${categoryId}`,
    // );
  }

  const item = (category.items || []).find((item) => item.id === itemId);

  // console.log("[ChargesService] Matched item:", item);

  if (!item) {
    throw new Error(`Charge item not found in current version: ${itemId}`);
  }

  return {
    catalog,
    category,
    item,
  };
};
